// String.fromCharCode takes one argument per byte, and engines cap the argument count, so a photo is
// converted a slice at a time
const BYTES_PER_SLICE = 0x8000;

export const arrayBufferToBase64 = (arrayBuffer) => {
	const bytes = new Uint8Array(arrayBuffer);
	let binary = '';
	for (let offset = 0; offset < bytes.length; offset += BYTES_PER_SLICE) {
		binary += String.fromCharCode.apply(null, bytes.subarray(offset, offset + BYTES_PER_SLICE));
	}

	return btoa(binary);
};
